import type { StatusTone } from '@/lib/runTelemetry';

const BILLING_STATUS: Record<string, { label: string; tone: StatusTone }> = {
  active: { label: 'Active', tone: 'success' },
  trialing: { label: 'Trial', tone: 'success' },
  past_due: { label: 'Past due', tone: 'warning' },
  unpaid: { label: 'Unpaid', tone: 'warning' },
  incomplete: { label: 'Payment pending', tone: 'warning' },
  incomplete_expired: { label: 'Payment expired', tone: 'danger' },
  canceled: { label: 'Canceled', tone: 'danger' },
  paused: { label: 'Paused', tone: 'neutral' },
};

/** A Stripe subscription status as an admin reads it, with the pill tone that goes with it. */
export function billingStatus(status: string | undefined): { label: string; tone: StatusTone } {
  if (status && Object.hasOwn(BILLING_STATUS, status)) return BILLING_STATUS[status];
  return { label: 'No plan', tone: 'neutral' };
}
